<template>
  <div ref="imageToFile" :style="{ backgroundImage: shareBgColor }">
    <div class="poster-bg">
      <div class="slide">
        <div class="card-title">
          <div>{{ actiName | ellipsis }}</div>
        </div>
        <div class="card-text">
          <div class="card-desc" :style="{ color: cardDescColor }" v-html="message">{{ message }}</div>
        </div>
        <div class="card-notes">
          <div class="card-nikname">
            <div class="nik-icon"><img :src="userAvatarImg" alt="" /></div>
            <div class="nik-name">{{ userInfo.userName }}</div>
          </div>
          <div class="nik-words">
            {{ numbers.message }}
          </div>
        </div>
        <div class="card-bottom">
          <div class="qr-code">
            <div class="code-text">{{ codeTxt }}</div>
            <div class="code-pic">
              <img :src="imgUrl" alt="" />
            </div>
          </div>
        </div>
      </div>
      <img class="bgimg" :src="posterImage" crossOrigin="anonymous" />
    </div>
  </div>
</template>
<script>
import { qrcanvas } from "qrcanvas"
import { mapGetters } from "vuex"
//import html2canvas from "html2canvas"
import forMatetextNumber from "@/utils/forMatetextNumber"
// const urlWeb = window.location.origin + window.location.pathname
export default {
  name: "PosterCardImg",
  props: {
    numbers: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      webUrl: "",
      imgUrl: "",
      message: ""
    }
  },
  created() {
    this.createPicture2()
    let styleColor = `color:${this.fontColor};font-size:50px;margin:0 24px;font-weight:600`
    if (this.numbers.likeCount >= 0) {
      this.message = forMatetextNumber(this.posterClockText, this.numbers.likeCount, styleColor)
    }
  },
  methods: {
    createPicture2() {
      let that = this
      this.webUrl = window.location.origin + window.location.pathname + "#/?id=" + this.activityId
      that.$nextTick(() => {
        var canvas1 = qrcanvas({
          data: decodeURIComponent(this.webUrl),
          size: 130
        })
        var imgData = canvas1.toDataURL("image/png")
        this.imgUrl = imgData
      })
    }
  },
  filters: {
    //超过十五个字符用...省略
    ellipsis(value) {
      if (!value) return ""
      if (value.length > 14) {
        return value.slice(0, 14) + "..."
      }
      return value
    }
  },
  computed: {
    ...mapGetters({
      userInfo: "userInfo/userInfo",
      shareBgColor: "activityInfo/shareBgColor",
      actiName: "activityInfo/actiName",
      posterClockText: "activityInfo/posterClockText",
      fontColor: "activityInfo/fontColor",
      posterImage: "activityInfo/posterImage",
      activityId: "activityInfo/activityId"
    }),
    cardDescColor() {
      function hexToRgb(hex) {
        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
        return result
          ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16)
            }
          : {}
      }
      const { r, g, b } = hexToRgb(this.fontColor)
      return `rgba(${r}, ${g}, ${b}, 0.7)`
    },
    userAvatarImg() {
      return this.activityId !== "179" ? this.userInfo.userAvatarImg : this.userInfo.userAvatarImg_1
    },
    codeTxt() {
      if (this.activityId === "200" || (process.env.VUE_APP_SCRIPT_ENV === "test" && this.activityId === "149")) {
        return "识别二维码参与"
      }
      return this.activityId !== "179" ? "识别二维码进入参与" : "长按二维码参与"
    }
  },
  mounted() {
    // this.createPicture2()
  }
}
</script>
<style lang="scss" scoped>
.poster-bg {
  width: 750px;
  height: 1145px;
  // background: linear-gradient(-180deg, #b9e4d0 0%, #94d1d3 96%);
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  border-radius: 0.2rem;
  overflow: hidden;
  .bgimg {
    width: 750px;
    height: 1145px;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    margin: 0 auto;
    z-index: -1;
  }
  .slide {
    width: 650px;
    height: 840px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    background: transparent;
    position: absolute;
    left: 0;
    top: 66px;
    bottom: 0;
    right: 0;
    margin: 0 auto;
    z-index: 1;
    .card-title {
      width: 630px;
      height: 100px;
      line-height: 100px;
      font-family: PingFang-SC-Bold;
      font-size: 32px;
      color: #ffffff;
      letter-spacing: 0;
      text-align: center;
      position: absolute;
      top: 48px;
    }
    .card-text {
      width: 570px;
      height: 132px;
      position: absolute;
      top: 211px;
      .card-desc {
        min-height: 132px;
        font-family: PingFang-SC-Bold;
        font-size: 36px;
        letter-spacing: 0;
        line-height: 66px;
        font-weight: bold;
        span {
          padding: 0 10px;
          font-family: PingFang-SC-Bold;
          font-size: 50px;
        }
      }
    }
    .card-notes {
      width: 630px;
      height: 90px;
      padding: 0 40px;
      position: absolute;
      top: 383px;
      .card-nikname {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        font-size: 32px;
        line-height: 42px;
        .nik-icon {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 20px;
          img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
          }
        }
      }
      .nik-words {
        font-size: 28px;
        line-height: 36px;
        width: 100%;
        min-height: 113px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 20px;
        border-radius: 16px;
        background: url("../../../assets/images/bg_comment_up.png") no-repeat;
        background-size: cover;
        background-position: 4px 8px;
      }
    }
    .card-bottom {
      position: absolute;
      left: 0;
      bottom: -4px;
      z-index: 10;
      width: 650px;
      display: flex;
      justify-content: flex-end;
      padding: 0 40px;
      .qr-code {
        width: 254px;
        height: 130px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        .code-text {
          flex: none;
          width: 150px;
          height: 72px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          flex-wrap: wrap;
          font-family: PingFangSC-Regular;
          font-size: 28px;
          line-height: 36px;
          color: #999999;
          text-align: right;
          margin-right: 14px;
          font-weight: normal;
        }
        .code-pic {
          width: 130px;
          height: 130px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 130px;
            height: 130px;
          }
        }
      }
    }
  }
}
</style>
